import { gql } from '@apollo/client';

export const PRODUCT_INFO = gql`
  fragment productInfo on SearchPartsResponse {
    description
    listPrice
    discountTotal
    extendedWarrantyEligible
    sellPrice
    priceLine
    partName
    partNumber
    discountType
    customSku
    maximumOrderQuantity
    minimumOrderQuantity
    isEligibleForCSAP
    csapPricePerUnit
    csapGroupDescription
    images {
      imageAlt
      imageAbsoluteUrl
    }
    description
    bom {
      partNumber
      productDetails {
        partName
        description
        extendedWarrantyEligible
        isEligibleForCSAP
        csapPricePerUnit
        csapGroupDescription
      }
      quantity
    }
  }
`;
